import { Injectable } from '@angular/core';
import {BaseService} from './base.service';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ItemsList} from '../model/itemsList';
import {AccessLog} from '../model/accessLog';
import {map} from 'rxjs/operators';
import { AccessLogFilter } from '../model/accessLogFilter';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Log } from '../util/log';


@Injectable({
  providedIn: 'root'
})
export class AccessLogService extends BaseService {

  private accessLogsList;
  private accessLogsObservable;

  constructor(http: HttpClient, afAuth: AngularFireAuth) {
    super(http, afAuth); 
  }

  getAccessLogs(deviceSerial: string, from: Date, to: Date, mustRenewData: boolean = false): Observable<AccessLog[]> {

    if (!mustRenewData && this.accessLogsList) {

      return of(this.accessLogsList);

    } else if (this.accessLogsObservable) {

      return this.accessLogsObservable;

    } else {

      let filter = new AccessLogFilter();
      filter.deviceSerial = deviceSerial;
      filter.from = from;
      filter.to = to;

      this.accessLogsObservable = this.postData<ItemsList<AccessLog[]>>('getAccesses', filter).pipe(
        map((data) => {

            this.accessLogsObservable = null;

            Log.debug('getAccessLogs: ' + JSON.stringify(data));

            const o = Object.create(ItemsList.prototype);
            Object.assign(o, data);
            o.items = data.items.map(item => new AccessLog().deserialize(item));

            Log.debug('accesses: ' + JSON.stringify(o.items));

            this.accessLogsList = o.items;

            return this.accessLogsList;
          }
        ));

      return this.accessLogsObservable;
    }
  }
}
